import { useEffect } from 'react';

interface SchemaOrgData {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

export const useSchemaOrg = (data: SchemaOrgData) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.id = 'schema-org-jsonld';
    
    const existingScript = document.getElementById('schema-org-jsonld');
    if (existingScript) {
      existingScript.remove();
    }
    
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.getElementById('schema-org-jsonld');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [data]);
};

export const getCafeSchemaOrg = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'CafeOrCoffeeShop',
    name: 'Mola Közde Kahveci',
    description: 'Türkiye\'nin ilk ve tek közde kahve konseptini sunan özel kafe. 1988\'den beri geleneksel Türk kahvesi kültürünü modern dokunuşla harmanlayan benzersiz lezzet deneyimi.',
    url: siteUrl,
    telephone: '+905322937352',
    email: 'info@molakozde.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Caferağa, Mühürdar Cd. No:25',
      addressLocality: 'Kadıköy',
      addressRegion: 'İstanbul',
      postalCode: '34710',
      addressCountry: 'TR'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '40.9877',
      longitude: '29.0268'
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ],
      opens: '00:00',
      closes: '23:59'
    },
    servesCuisine: 'Türk Kahvesi',
    priceRange: '$$',
    image: 'https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/98eb314ca98fe48673f68b7098bb86f0.png',
    sameAs: [
      'https://www.instagram.com/__kahve_molasi__/',
      'https://wa.me/905322937352'
    ],
    foundingDate: '1988',
    slogan: 'Türkiye\'nin İlk Közde Kahvecisi'
  };
};

export const getFAQSchemaOrg = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Közde kahve nedir?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Közde pişirme, Türk kahvesinin geleneksel ateş üzerinde, közün sıcaklığıyla yavaş yavaş pişirilmesi yöntemidir. Bu teknik, kahvenin aromasını ve tadını en üst seviyeye çıkarır. Közün eşit ısısı sayesinde kahve köpüğü mükemmel bir şekilde oluşur ve kahvenin gerçek lezzeti ortaya çıkar.'
        }
      },
      {
        '@type': 'Question',
        name: 'Mola Közde Kahveci çalışma saatleri nedir?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Mola Közde Kahveci 7/24 açıktır. Her gün hizmetinizdeyiz.'
        }
      },
      {
        '@type': 'Question',
        name: 'Mola Közde Kahveci nerede?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Mola Közde Kahveci, Kadıköy\'de Caferağa, Mühürdar Cd. No:25, 34710 Kadıköy/İstanbul adresinde bulunmaktadır.'
        }
      },
      {
        '@type': 'Question',
        name: 'Rezervasyon yapılabiliyor mu?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Evet, grup rezervasyonları için lütfen 0532 293 73 52 numaralı telefondan önceden arayın.'
        }
      }
    ],
    url: siteUrl
  };
};

export const getLocalBusinessSchemaOrg = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${siteUrl}#localbusiness`,
    name: 'Mola Közde Kahveci',
    description: 'Kadıköy\'de Türkiye\'nin ilk ve tek közde kahve konseptini sunan özel kafe',
    url: siteUrl,
    telephone: '+905322937352',
    email: 'info@molakozde.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Caferağa, Mühürdar Cd. No:25',
      addressLocality: 'Kadıköy',
      addressRegion: 'İstanbul',
      postalCode: '34710',
      addressCountry: 'TR'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '40.9877',
      longitude: '29.0268'
    },
    hasMap: 'https://www.google.com/maps/search/?api=1&query=40.9877,29.0268',
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ],
      opens: '00:00',
      closes: '23:59'
    },
    priceRange: '$$',
    image: 'https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/98eb314ca98fe48673f68b7098bb86f0.png',
    sameAs: [
      'https://www.instagram.com/__kahve_molasi__/',
      'https://wa.me/905322937352'
    ]
  };
};
